















































































































































































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Currency from "@/components/currency.vue";
import Highlight from "@/components/highlight/highlight";
import DebtCollection from "@/components/icons/debt-collection.vue";
import Invoicing from "@/components/icons/invoicing.vue";
import Service from "@/components/icons/service.vue";
import CaseModel from "@/models/CaseModel";
import SystemModel from "@/models/SystemModel";
import dayjs from "dayjs";
import { UserModule } from '@/store/modules/User';

interface Details {
    email: string;
    telephone: string;
    telefax: string;
    lastPaymentDate: string;
    numFullyPaidCases: number;
    numInstallmenPlans: number;
    sumPaid: number;
    sumRemaining: number;
}

@Component({
    components: { Highlight, Currency, DebtCollection, Invoicing, Service }
})
export default class SearchCustomerCollection extends Vue {
    showOpenCases = true;
    showClosedCases = true;
    searchString = "";

    @Prop()
    cases!: Array<any>;

    @Prop()
    customerDetails!: Details;

    @Prop()
    loadingDetails!: boolean;

    @Prop()
    country!: string;

    @Prop(Object)
    system!: any;

    get lastPaymentDate() {
        if (!this.customerDetails.lastPaymentDate) {
            return "-";
        }

        const date = dayjs(this.customerDetails.lastPaymentDate, "YYYYMMDD");

        return this.$format.date(date.toDate());
    }

    get translatedCases() {
        return this.cases.map(caseData => {
            caseData.info.translatedStatus = this.getTranslation(caseData.info);

            return caseData;
        });
    }

    get filteredCases() {
         if (this.showOpenCases && !this.showClosedCases) {
            return this.filterCases(this.openCases);
        } else if (this.showClosedCases && !this.showOpenCases) {
            return this.filterCases(this.closedCases);
        } else if (!this.showClosedCases && !this.showOpenCases) {
             return [];
         }

        return this.filterCases(this.translatedCases);
    }

    get openCases() {
        return this.translatedCases.filter(caseData => caseData.info.closureDate == null);
    }

    get closedCases() {
        return this.translatedCases.filter(caseData => caseData.info.closureDate != null);
    }

    get searchLowerCase() {
        return this.searchString.toLocaleLowerCase();
    }

    get isMobile() {
        return UserModule.isMobileGlobal;
    }

    filterCases(cases: any[]) {
        return cases.filter(caseData => {
            return caseData.creditor.creditorName.toLocaleLowerCase().includes(this.searchLowerCase)
                || caseData.info.regDate.toLocaleLowerCase().includes(this.searchLowerCase)
                || caseData.info.caseNo.toString().includes(this.searchLowerCase)
                || caseData.info.translatedStatus.toLocaleLowerCase().includes(this.searchLowerCase);
        });
    }

    openCase(id: number, system: any) {
        const routeName = this.isCollection(system) ? "search-collection" : this.isPreCollection(system) ? "search-invoicing" : "search-service";
        this.$router.push({ name: routeName, params: { id: id.toString() }, query: this.$route.query });
    }

    getTranslation({ statusCode, closureDate }: { statusCode: string; closureDate: string | null }) {
        const translation = (translationString: string) => {
            return this.$te(translationString) ? this.$t(translationString) as string : statusCode;
        };

        return closureDate ? translation(`externalTranslations.CLOSURE.${statusCode}`) : translation(`externalTranslations.STATUS.${statusCode}`);
    }

    isJointCase(caseType: number) {
        return CaseModel.isJointCase(caseType);
    }

    isCollection(system: any) {
        return SystemModel.isCollection(system);
    }

    isPreCollection(system: any) {
        return SystemModel.isPreCollection(system);
    }

    isService(system: any) {
        return SystemModel.isService(system);
    }
}
